import React from 'react';
import axios from 'axios';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import ambiente from '../../config/ambienteConfig';
import { exibirMensagem } from '../../redux/actions/mensagemAction';
import MovRow from './MovRow';

class MovAtivo extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			ativo: {},
			movimentacoes: [],
			movimentacao: {
				tipo: 'COMPRA',
				data: moment(),
				quantidade: '',
				preco: '',
				custos: '',
				ativo_id: ''
			},
			ativos: [],
			primeiraCompra: false,
			redirecionar: false
		};
	}

	componentDidMount = async () => {
		try {
			//Obtendo o id do ativo
			if (this.props.match.params.id) {
				const res = await axios.get(`${ambiente.dev.server}/ativos/${this.props.match.params.id}`);
				const movimentacao = Object.assign({}, this.state.movimentacao, { ativo_id: res.data.id });
				this.setState({ ativo: res.data, movimentacao });

				this.atualizarMovimentacoes();
			} else {
				const res = await axios.get(`${ambiente.dev.server}/ativos`);
				const ativos = res.data.filter(item => item.tipo !== 'RFIXA');
				this.setState({ ativos, primeiraCompra: true });
				this.handleChangeMovAtt('ativo_id', ativos[0].id);
			}
		} catch (err) {
			this.props.exibirMensagem('err', `Erro: ${err}`);
		}
	};

	atualizarMovimentacoes = async () => {
		const resMov = await axios.get(`${ambiente.dev.server}/movimentacoes?ativo=${this.props.match.params.id}`);
		this.setState({ movimentacoes: resMov.data });
	};

	handleChangeMovAtt(nome, valor) {
		const movimentacao = Object.assign({}, this.state.movimentacao);
		movimentacao[nome] = valor;
		this.setState({ movimentacao });
	}

	handleSave = async () => {
		try {
			await axios.post(`${ambiente.dev.server}/movimentacoes`, this.state.movimentacao);
			this.props.exibirMensagem('yay', `Movimentação inserida com sucesso!`);
			this.atualizarMovimentacoes();
			if (this.state.primeiraCompra) this.setState({ redirecionar: true });
		} catch (err) {
			this.props.exibirMensagem('err', `Erro: ${err}`);
		}
	};

	handleDelete = async id => {
		try {
			await axios.delete(`${ambiente.dev.server}/movimentacoes/${id}`);
			this.props.exibirMensagem('yay', `Movimentação removida com sucesso!`);
			this.atualizarMovimentacoes();
		} catch (err) {
			this.props.exibirMensagem('err', `Erro: ${err}`);
		}
	};

	render() {
		if (this.state.redirecionar) return <Redirect to="/carteira" />;
		const movimentacao = this.state.movimentacao;
		return (
			<div>
				<div className="row">
					<div className="form-group col-6 col-md-4">
						{this.state.primeiraCompra ? (
							<select autoFocus
								className="form-control"
								value={movimentacao.ativo_id}
								onChange={evt => this.handleChangeMovAtt('ativo_id', evt.target.value)}>
								{this.state.ativos.map(item => (
									<option key={item.id} value={item.id}>
										{item.nome}
									</option>
								))}
							</select>
						) : (
								<h3>{this.state.ativo.nome}</h3>
							)}
					</div>
					<div className="form-group col-6 col-md-4" data-toggle="buttons">
						<button autoFocus
							type="button"
							onClick={() => this.handleChangeMovAtt('tipo', 'COMPRA')}
							className={`btn btn-sm ${movimentacao.tipo === 'COMPRA' ? 'btn-success active' : 'btn-secondary'}`}>
							<i className="fas fa-thumbs-up" />
						</button>
						<button
							type="button" disabled={this.state.primeiraCompra}
							onClick={() => this.handleChangeMovAtt('tipo', 'VENDA')}
							className={`btn btn-sm ${movimentacao.tipo === 'VENDA' ? 'btn-danger active' : 'btn-secondary'}`}>
							<i className="fas fa-thumbs-down" />
						</button>
						<button
							type="button" disabled={this.state.primeiraCompra}
							onClick={() => this.handleChangeMovAtt('tipo', 'BONIF')}
							className={`btn btn-sm ${movimentacao.tipo === 'BONIF' ? 'btn-info active' : 'btn-secondary'}`}>
							<i className="fas fa-gift" />
						</button>
					</div>
					<div className="form-group col col-md-4">
						<input
							type="date"
							className="form-control"
							value={movimentacao.data.format('YYYY-MM-DD')}
							onChange={evt => this.handleChangeMovAtt('data', moment(evt.target.value, 'YYYY-MM-DD'))}
						/>
					</div>
				</div>
				<div className="row">
					<div className="form-group col">
						<input
							type="text"
							className="form-control"
							value={movimentacao.quantidade}
							placeholder="Quantidade"
							onChange={evt => this.handleChangeMovAtt('quantidade', evt.target.value)}
						/>
					</div>
					<div className="form-group col">
						<input
							type="number" step="0.01"
							className="form-control"
							value={movimentacao.preco}
							placeholder="Preço"
							onChange={evt => this.handleChangeMovAtt('preco', evt.target.value)}
						/>
					</div>
					<div className="form-group col">
						<input
							type="number" step="0.01"
							className="form-control"
							value={movimentacao.custos}
							placeholder="Custos"
							onChange={evt => this.handleChangeMovAtt('custos', evt.target.value)}
						/>
					</div>
				</div>
				<button type="button" className="btn btn-primary btn-block" onClick={this.handleSave}>
					Salvar
				</button>
				<div className="list-group">
					{!this.state.primeiraCompra &&
						this.state.movimentacoes &&
						this.state.movimentacoes.map(item => <MovRow key={item.id} {...item} handleDelete={this.handleDelete} />)}
				</div>
			</div>
		);
	}
}

MovAtivo.propTypes = {
	exibirMensagem: PropTypes.func.isRequired
};

function mapStateToProps(state) {
	return {};
}

function mapDispatchToProps(dispatch) {
	return {
		exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto))
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(MovAtivo);



// WEBPACK FOOTER //
// ./src/components/MovAtivo/MovAtivo.js